"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.value = exports.symbol = void 0;
/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const symbol = exports.symbol = /*#__PURE__*/Symbol.for("effect/PrimaryKey");
/**
 * @since 2.0.0
 * @category accessors
 */
const value = self => self[symbol]();
exports.value = value;
//# sourceMappingURL=PrimaryKey.js.map